export const GRID_COLS = 12;
export const GRID_ROWS = 8;
export const CELL_COUNT = GRID_COLS * GRID_ROWS;
export const ROUND_MS = 45_000;

export type AppRoute = "/" | "/stats" | "/settings" | "/help";
export type AttentionStage = "idle" | "priming" | "running" | "reveal" | "completed" | "archived";

export interface Stimulus {
  id: string;
  index: number;
  title: string;
  body: string;
  glyph: string;
  family: "edge" | "motion" | "meaning" | "threat" | "novelty" | "social" | "pattern" | "quiet";
  salience: number;
  trick: string;
}

export interface HeatCell {
  i: number;
  dwellMs: number;
  touches: number;
  visits: number;
  longPresses: number;
  firstAt?: number;
  lastAt?: number;
}

export interface RoundMetrics {
  coverage: number;
  entropy: number;
  totalDwellMs: number;
  touches: number;
  visits: number;
  revisits: number;
  edgeBias: number;
  centerBias: number;
  semanticBias: number;
  skipPressure: number;
  heat: HeatCell[];
}

export interface SelfReport {
  remembered: number[];
  ignoredZone?: "top" | "right" | "bottom" | "left" | "center";
  surprise?: string;
}

export interface LocalSession {
  id: string;
  roomId: string;
  deviceHash: string;
  createdAt: string;
  updatedAt: string;
  consentVersion: string;
  metrics: RoundMetrics;
  selfReport: SelfReport;
  oracle: AttentionOracle;
  meta?: Record<string, unknown>;
  tags?: string[];
}

export interface AttentionOracle {
  name: string;
  confidence: number;
  line: string;
  gifts: string[];
  blindspots: string[];
  commonsDelta: string;
}

export interface CommonsCell {
  i: number;
  dwellMs: number;
  touches: number;
  visits: number;
  sessions?: number;
}

export interface CommonsSummary {
  updatedAt: string;
  cells: CommonsCell[];
  topSkipped: number[];
  topHeld: number[];
  sessions: number;
}

export interface AttestationResponse {
  attest: string;
  expiresAt: string;
  consentVersion: string;
}
